import { StyleSelector as ImageStyleSelector } from '@/components/nodes/image/style-selector';
import { VideoStyleSelector } from '@/components/nodes/video/style-selector';

type StyleItemProps = {
  id: string;
  value: string;
  onChange: (value: string, prompt: string) => void;
  disabled?: boolean;
  width?: number | string | 'auto';
  variant?: 'image' | 'video';
  modelId?: string;
  mode?: 'txt2img' | 'img2img';
};

export function StyleItem({ id, value, onChange, disabled, width = 'auto', variant = 'image', modelId, mode }: StyleItemProps) {
  if (variant === 'video') {
    return (
      <VideoStyleSelector
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        width={width}
        className="rounded-md h-8"
      />
    );
  }
  return (
    <ImageStyleSelector
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      width={width}
      modelId={modelId}
      mode={mode}
      className="rounded-md h-8"
    />
  );
}


